import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-200/60 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-table-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading font-semibold text-lg text-foreground-900">
                Vigorbuy Spreadsheet Hub
              </span>
            </Link>
            <p className="text-foreground-600 text-xs leading-relaxed mb-4">
              Your comprehensive resource for Vigorbuy Spreadsheet guides, product categories, comparison tools, and shopping research. Helping shoppers make informed decisions since 2026.
            </p>
            <p className="text-foreground-500 text-xs">
              An independent educational resource. Not a payment platform. Not a marketplace.
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-900 text-sm mb-4">Quick Links</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-foreground-600 hover:text-foreground-900 text-xs transition-colors cursor-pointer">Home</Link>
              </li>
              <li>
                <Link to="/vigorbuy-spreadsheet-beginner-guide" className="text-foreground-600 hover:text-foreground-900 text-xs transition-colors cursor-pointer">Beginner Guide</Link>
              </li>
              <li>
                <a href="#categories" className="text-foreground-600 hover:text-foreground-900 text-xs transition-colors cursor-pointer">Categories</a>
              </li>
              <li>
                <a href="#faq-section" className="text-foreground-600 hover:text-foreground-900 text-xs transition-colors cursor-pointer">FAQ</a>
              </li>
              <li>
                <a href="#safety-section" className="text-foreground-600 hover:text-foreground-900 text-xs transition-colors cursor-pointer">Safety Guide</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-900 text-sm mb-4">Product Categories</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 8).map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-foreground-600 hover:text-foreground-900 text-xs transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-900 text-sm mb-4">More Categories</h4>
            <ul className="space-y-2.5">
              {categories.slice(8).map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-foreground-600 hover:text-foreground-900 text-xs transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
              <li>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-primary-600 hover:text-primary-700 text-xs font-medium transition-colors cursor-pointer"
                >
                  Visit Main Website <i className="ri-external-link-line text-[10px] ml-1"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-500 text-xs">
            &copy; {new Date().getFullYear()} Vigorbuy Spreadsheet Hub. All rights reserved. Built for educational purposes.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/" className="text-foreground-500 hover:text-foreground-700 text-xs transition-colors cursor-pointer">Privacy Policy</Link>
            <Link to="/" className="text-foreground-500 hover:text-foreground-700 text-xs transition-colors cursor-pointer">Terms of Use</Link>
            <Link to="/" className="text-foreground-500 hover:text-foreground-700 text-xs transition-colors cursor-pointer">Contact</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}